interface LightbulbThemeToggleProps {
  toggled: boolean
  onToggle: (toggled: boolean) => void
}

export function LightbulbThemeToggle({ toggled, onToggle }: LightbulbThemeToggleProps) {
  const raysClassName = toggled ? 'scale-75 opacity-0' : 'scale-100 opacity-100'
  const filamentClassName = toggled ? 'opacity-30' : 'opacity-100'

  return (
    <button
      type="button"
      onClick={() => onToggle(!toggled)}
      aria-label="Toggle dark mode"
      aria-pressed={toggled}
      className="inline-flex size-10 items-center justify-center rounded-lg text-xl text-[color:var(--theme-muted)] transition-colors hover:bg-[color:var(--theme-hover)] hover:text-[color:var(--theme-fg)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--theme-fg)] focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--theme-bg)]"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 32 32"
        className="size-[1em]"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          className={`origin-center transition-[opacity,transform] duration-slow motion-reduce:transition-none ${raysClassName}`}
        >
          <path d="M16 1.5v4" />
          <path d="m5.7 5.7 2.8 2.8" />
          <path d="M1.5 16h4" />
          <path d="m26.3 5.7-2.8 2.8" />
          <path d="M26.5 16h4" />
        </g>
        <path d="M12.4 27.3h7.2M12.9 29.7h6.2" />
        <path d="M9.8 22.3a9 9 0 1 1 12.4 0c-1.3 1.4-2.1 2.7-2.5 4.1h-7.4c-.4-1.4-1.2-2.7-2.5-4.1Z" />
        <path
          className={`transition-opacity duration-slow motion-reduce:transition-none ${filamentClassName}`}
          d="M13.1 17.3c.2-1.1 1-1.9 2-1.9.5 0 .9.2.9.6s.4.6.9.6c1 0 1.8-.8 2-1.9M14.6 26.4l.4-10.1M17.4 26.4 17 16.9"
        />
      </svg>
    </button>
  )
}
